import {createAction, props} from '@ngrx/store';
import {DokumentDTO} from '../../openapi/dokument-openapi';
import {AblageortPath} from '../../types/ablageort-path.type';

/**
 * Actions für das Upload-Feature.
 */
export class UploadActions {
  // Dialog
  public static openDialog = createAction('[Upload] Open dialog.');
  public static closeDialog = createAction('[Upload] Close dialog.');

  /* INFO: Die Datei wird über den UploadFileService übergeben,
     da File-Objekte nicht serialisierbar sind und nicht in NgRx-Actions gehören. */
  public static startUpload = createAction(
    '[Upload] Start upload.',
    props<{
      inhaberId: string;
      ablageort: string;
      bezeichnung: string;
      dokumentjahr: number;
      freigegeben: boolean;
      // Für die Erfolgsmeldung (werden im Store gespeichert)
      fileName: string;
      displayPath: string;
    }>()
  );

  public static uploadProgress = createAction(
    '[Upload] Upload progress updated.',
    props<{ progress: number }>()
  );

  public static uploadSuccess = createAction(
    '[Upload] Upload succeeded.',
    props<{ dokument: DokumentDTO }>()
  );

  public static uploadFailure = createAction(
    '[Upload] Upload failed.',
    props<{ status: number; message: string }>()
  );

  public static navigationCompleted = createAction('[Upload] Navigation completed.');

  public static resetState = createAction('[Upload] Reset state.');
}
